<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500"
  >
    <v-card :outlined="true" :raised="true">
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Logged out
      </v-card-title>

      <v-card-text>
        <p>You were inactive for too long.</p>
        <p>To protect your privacy, you have been automatically logged out.</p>
        <p>Sign in again to continue.</p>
      </v-card-text>

      <v-divider/>

      <v-card-actions class="pr-6 pb-6">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          @click="redirect()"
          style="width: 120px; height: 50px; font-size: 16px; font-weight: bold;"
        >
          Sign in
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "SessionExpired",
    data() {
      return {
        dialog: true,
      }
    },
    methods: {
      redirect() {
        window.location = '/auth/saml/redirect';
      }
    }
  }
</script>

<style scoped>

</style>
